import { useClient } from 'jsonapi-react';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { t } from 'i18next';
import { FormTaxonomy } from '@/components/custom/form';

export default function StepName(props) {
  const { step, form, titleError } = props;
  const [isOpenModalTaxonomies, setIsOpenModalTaxonomies] = useState(false);
  const [taxonomies, setTaxonomies] = useState([]);
  const [isLoadingTaxonomies, setIsLoadingTaxonomies] = useState(false);
  const client = useClient();

  const getTaxonomies = async () => {
    setIsLoadingTaxonomies(true);

    try {
      const { data } = await client.fetch('taxonomies');
      setTaxonomies(data);
    } catch {
      toast.error('Erro ao carregar taxonomias');
    } finally {
      setIsLoadingTaxonomies(false);
    }
  };

  useEffect(() => {
    getTaxonomies();
  }, []);

  return (
    step === 'nome' && (
      <div className="page__content mb-12 animate-fade-in">
        <div className="new-questions__header">
          <h2 className="new-questions__title">{t('activity.newActivityTitle')}</h2>
        </div>

        <div className="new-questions__body">
          <p className="new-questions__subtitle">{t('activity.newActivityDescription')}</p>
          <div className="form__row">
            <label
              className="form__label"
              htmlFor="title"
            >
              *{t('activity.activityName')}
            </label>
            <input
              className="form__control"
              placeholder={t('activity.placeholderActivityName')}
              id="title"
              name="title"
              type="text"
              value={form?.values?.title}
              onChange={e => form?.setFieldValue('title', e.target.value)}
            />
            {titleError && <span style={{ color: 'red' }}>{t('warning.requiredField')}</span>}
          </div>

          <FormTaxonomy
            label={t('tasks.mattersRelated')}
            isLoading={isLoadingTaxonomies}
            taxonomies={taxonomies}
            selectedTaxonomies={form?.values?.selectedTaxonomies}
            setFieldValue={form?.setFieldValue}
            errors={form?.errors}
            touched={form?.touched}
            isOpenModalTaxonomies={isOpenModalTaxonomies}
            setIsOpenModalTaxonomies={setIsOpenModalTaxonomies}
          />
        </div>

        <span className="form__text">
          <strong>* {t('warning.requiredField')}</strong>
        </span>
      </div>
    )
  );
}
